import { type } from '../actions/type';


const INITIAL_STATE = {
    apiLogs: {
        searchTerm: null,
        logs: null
    },
    extensionLogs: {
        searchTerm: null,
        logs: null
    },
    smtpPushLogs: {
        searchTerm: null,
        logs: null
    },
    outboundLogs: {
        searchTerm: null,
        logs: null
    },
    draftEditLogs: {
        searchTerm: null,
        logs: null
    },
    processingLogs: {
        searchTerm: null,
        logs: null
    },
    sheetLogs: {
        searchTerm: null,
        logs: null
    },
    warmupLogs: {
        searchTerm: null,
        logs: null
    },
    smtpLogs: {
        searchTerm: null,
        logs: null
    },
    campaignErrorLogs: {
        searchTerm: null,
        logs: null
    },
    statusLogs: {
        searchTerm: null,
        logs: null
    },
    selectedLogType: '',

}

const logReducer = (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case type.SELECT_LOG_TYPE:
            return { ...state, selectedLogType: action.payload.selectedLogType }

        case type.API_LOGS:

            return { ...state, apiLogs: { logs: action.payload.apiLogs, searchTerm: action.payload.searchTerm } };

        case type.EXTENSION_LOGS:

        return { ...state, extensionLogs: { logs: action.payload.extensionLogs, searchTerm: action.payload.searchTerm } };

        case type.SMTP_PUSH_LOGS:

        return { ...state, smtpPushLogs: { logs: action.payload.smtpPushLogs, searchTerm: action.payload.searchTerm } };

        case type.OUTBOUND_LOGS:

            return { ...state, outboundLogs: { logs: action.payload.outboundLogs, searchTerm: action.payload.searchTerm } };

        case type.DRAFTEDIT_LOGS:

            return { ...state, draftEditLogs: { logs: action.payload.draftEditLogs, searchTerm: action.payload.searchTerm } };

        case type.PROCESSING_LOGS:

            return { ...state, processingLogs: { logs: action.payload.processingLogs, searchTerm: action.payload.searchTerm } };

        case type.CAMPAIGN_ERROR_LOGS:

            return { ...state, campaignErrorLogs: { logs: action.payload.campaignErrorLogs, searchTerm: action.payload.searchTerm } };
        
        case type.STATUS_LOGS:
    
            return { ...state, statusLogs: { logs: action.payload.statusLogs, searchTerm: action.payload.searchTerm } };
                
        case type.SHEET_LOGS:

            return { ...state, sheetLogs: { logs: action.payload.sheetLogs, searchTerm: action.payload.searchTerm } };

        case type.WARMUP_LOGS:

            return { ...state, warmupLogs: { logs: action.payload.warmupLogs, searchTerm: action.payload.searchTerm } };
        
        case type.SMTP_LOGS:

            return { ...state, smtpLogs: { logs: action.payload.smtpLogs, searchTerm: action.payload.searchTerm } };

        default:
            return state;
    }
}
export default logReducer;